import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { getCmdIdFromRibbonId } from 'owa-mail-ribbon-store';
import { getActiveContentTab, TabType } from 'owa-tab-store';
import type { TabViewState } from 'owa-tab-store';
import { MailRibbonControlId } from 'owa-ribbon-ids';

const shouldEnableMap = getMailMenuItemShouldShowMap();

/**
 * These RibbonIds are excluded from the logic in disabledInSecondaryPane inside of getIsButtonDisabled()
 */
const idsNotDisabledInSecondaryPane = [
    MailRibbonControlId.NewContact,
    MailRibbonControlId.NewEvent,
    MailRibbonControlId.NewGroup,
    MailRibbonControlId.NewItems,
    MailRibbonControlId.NewMessage,
    MailRibbonControlId.NewMessageSplitButton,
    MailRibbonControlId.NewNote,
    MailRibbonControlId.NewTask,
    MailRibbonControlId.NewTeamsMeeting,
    MailRibbonControlId.NewYammerPost,
    MailRibbonControlId.ToggleLeftPane,
];

export const getIsButtonDisabled = (controlId: number | string, isPopout: boolean): boolean => {
    const id: number = getNumericRibbonId(controlId);
    let disabledInSecondaryPane: boolean = false;

    if (!isPopout) {
        const activeTab: TabViewState = getActiveContentTab();

        disabledInSecondaryPane =
            activeTab &&
            activeTab.type == TabType.SecondaryReadingPane &&
            !idsNotDisabledInSecondaryPane.includes(id);
    }

    return disabledInSecondaryPane || !shouldEnableMap[getCmdIdFromRibbonId(id)]();
};

function getNumericRibbonId(id: number | string): number {
    return typeof id == 'string' ? parseInt(id) : id;
}
